import { createSelector } from 'reselect'

export const root = state => state.get('pardot')

export const getMappings = createSelector(
    root,
    root => root.integrationMappings
)

export const getFields = createSelector(
    root,
    root => root.integrationFields
)

export const didPatchErr = createSelector(
    root,
    root => root.integrationMappingsErr
)

export const isPatchLoading = createSelector(
    root,
    root => root.integrationPatchLoading
)


// WEBPACK FOOTER //
// ./src/scripts/app/modules/pardot/selectors.js